<script lang="ts" setup>
import { ref } from 'vue'
import { useFetch } from '@/home/hooks/fetch';
import RecommendOrganization from './RecommendOrganization.vue';
import InfiniteScroll from '@/home/components/InfiniteScroll.vue';

const { $fetch } = useFetch();
const listing = ref<Record<string, any>>([]);

let page = 1;
const loading = ref(false);
const finished = ref(false);

// 加载更多数据
const loadMoreData = async () => {
  if (finished.value) {
    return;
  }

  const { isSuccess, data } = await $fetch('/org/home_org_list', {
    method: 'post',
    data: {
      pageNum: page,
      pageSize: 10,
    },
  });

  if (isSuccess && data?.records?.length) {
    page++;
    listing.value.push(...data.records);
  }
  else {
    finished.value = true;
  }

  loading.value = false;
}
</script>

<template>
  <section>
    <InfiniteScroll v-model:loading="loading" :finished="finished" @load="loadMoreData">
      <li v-for="(item, index) in listing" :key="index" class="group bg-[#fff] px-24 hover:bg-[#3d7cfa] hover:bg-opacity-3">
        <RecommendOrganization :data="item" />
      </li>
    </InfiniteScroll>
  </section>
</template>

<style lang="scss" scoped>
</style>
